import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rds-output-page-header',
  templateUrl: './output-page-header.component.html',
  styleUrls: ['./output-page-header.component.scss']
})
export class OutputPageHeaderComponent implements OnInit {

  @Output() searchEmitter = new EventEmitter();
	
	@Input() title: string = '';
	@Input() subtitle: string = 'Home';
	@Input() hint:string='';

	@Input() icon: string = '';
	@Input() icon_color:string = '#000000';
	@Input() iconType:string = 'material-icons';//material-icons-outlined, material-icons, material-icons-round, material-icons-sharp, material-icons-two-tone
	
	@Input() bg_color = '#f4f5f7';
	@Input() status: string = '';
	@Input() statusLabel:string = '';

	statusMappingColor:any = {
		"success": "rds__badge-success",
		"success_2": "rds__badge-success-2",
		"open": "rds__badge-info",
		"hold": "rds__badge-secondary",
		"warning": "rds__badge-warning",
		"warning_2": "rds__badge-warning-2",
		"error": "rds__badge-error"
	}

  constructor() { }

  ngOnInit() {
  }

}
